<template>
  <Layout :company="model">
		<CandidateTable :company="model" :settings="settings" />
  </Layout>
</template>

<script>
import Layout from '@layouts/basic'
import CandidateTable from '@pages/company/candidateTable'
import { mapActions } from 'vuex'

export default {
	name: 'Login',
	data() {
		return {
			model:{},
			settings:{}
		}
	},
	methods:{
		...mapActions('company', ['findByToken'])
	},
  components: { Layout, CandidateTable},
	async beforeMount() {
		await this.findByToken(this.$route.query.key).then(res => {
			this.model = res.data.company
			this.settings = res.data.settings
		}).catch(() => {
			this.$router.push('/')
		})
	}
}
</script>